import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgSuccessFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fill: color, fillRule: "evenodd", d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm3.293 6.293L10 13.586l-1.293-1.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l6-6a1 1 0 10-1.414-1.414z" }));
};
export default factorySvgIcon(SvgSuccessFilled);
//# sourceMappingURL=SvgSuccessFilled.js.map